export type FaultSortKey = 'name' | 'code' | 'status' | 'count' | 'time';
export type SortDir = 'asc' | 'desc';

export interface SortableFault {
  description: string;
  faultCodeDisplay: string;
  faultCode: number;
  failureCode: number;
  now: 'active' | 'cleared' | null;
  faultCount: string;
  faultDateUtc: Date | string;
}

export const OTHER_FAULT_COLUMNS: { key: FaultSortKey; labelKey: string }[] = [
  { key: 'name', labelKey: '@fault' },
  { key: 'time', labelKey: '@lastUpdate' },
  { key: 'code', labelKey: '@faultCode' },
  { key: 'status', labelKey: '@status' },
  { key: 'count', labelKey: '@occurrences' },
];

const STATUS_RANK = { active: 0, cleared: 1 };
const statusRank = (now: SortableFault['now']): number => (now ? STATUS_RANK[now] : 2);
const nameOf = (f: SortableFault): string => f.description || f.faultCodeDisplay || '';

function compare(a: SortableFault, b: SortableFault, key: FaultSortKey): number {
  switch (key) {
    case 'name': return nameOf(a).localeCompare(nameOf(b));
    case 'code': return (a.faultCode - b.faultCode) || (a.failureCode - b.failureCode);
    case 'status': return statusRank(a.now) - statusRank(b.now);
    case 'count': return (Number(a.faultCount) || 0) - (Number(b.faultCount) || 0);
    case 'time': return new Date(a.faultDateUtc).getTime() - new Date(b.faultDateUtc).getTime();
  }
}

export function sortFaults<T extends SortableFault>(lines: T[], key: FaultSortKey, dir: SortDir): T[] {
  return [...lines].sort((a, b) => (dir === 'asc' ? compare(a, b, key) : compare(b, a, key)));
}
